import Request from '../Request';
import GoogleMap from "./IHMozuFuruGoogleMap";

/**
 * もずふる古墳群マップアプリ用コード
 * TODO: 汎用的に使える部分はモジュール化したい
 *
 * @type {IHMozuFuru}
 */
module.exports = class IHMozuFuru extends IH {
  constructor(options) {
    super(options);
  
    /**
     * 変数
     */
    this.options = options;
    this.searchTargetTypes = [];
    this.initLocationOrigin = {}; // 管理画面で設定された初期位置の保存用
    this._placeTypes = [];
    
    // GoogleMap マップタイプ・マップコントロール設定
    if (this.mapOptions.type === 'googlemap') {
      const gmap_options = {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ['terrain', 'satellite']
        },
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_TOP},
        styles: [
          {
            "featureType": "poi.business",
            "elementType": "all",
            "stylers": [
              { "visibility": "off" }
            ]
          }
        ],
        zoomControlOptions: {position: google.maps.ControlPosition.TOP_LEFT}
      };
      $.extend(true, this.mapOptions.gmap_options, gmap_options)
    }
    
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: this.translationsExtend.facet.moundShape.name,
      searchApi: 'search',
      mappingItems: {
        lat:         'lat',
        lng:         'lng',
        image:       'image',
        image_label: this.translationsExtend.attributes.imageLabel,
        name:        this.translationsExtend.attributes.name,
        address:     this.translationsExtend.attributes.address,
        description: this.translationsExtend.attributes.description
      },
      sortTarget: {
        mound:       this.translationsExtend.attributes.moundLength,
        era:         '年代区分',
        haniwa_era: '年代区分',
      },
      sortValue: {
        // 年代区分
        eras: {
          '4世紀後半': 1,
          '5世紀前半': 2,
          '5世紀後半': 3
        },
        haniwa_eras: {
          '4世紀後半': 1,
          '5世紀前半': 2,
          '5世紀後半': 3
        }
      },
      firstSelection: '候補に含まれる'
    };
    this.defaultSortKey = 'era';  // repository.sortResult()で時代順に並び替えた後、transformPlacesResponse()で資産番号順に並び替える
    this.defaultSortOrder = 1;
    this.sortKey_1 = 'era';
    this.sortOrder_1 = 1;
    this.sortKey_2 = 'mound';
    this.sortOrder_2 = -1;
    this.detailMenus = [
      this.translationsExtend.attributes.no,
      this.translationsExtend.attributes.kana,
      this.translationsExtend.facet.area.name,
      this.translationsExtend.attributes.address,
      this.translationsExtend.attributes.moundLength,
      this.translationsExtend.facet.era.name
    ];
    this.indexOfCandidate = 0;
    this.indexOfKana = 1;
    this.indexOfMoundLength = 4;
  
    /**
     * 固有設定
     */
    if (this.isProduction) {
      this.googleAnalyticsCode = this.options.googleAnalyticsCode;
    }
    this.numOfMap = 3;
    this.icon_default = this.icon_file_path + 'base_pin.png';
    this.labelingZoomLevel = 15;
    this.extent = null;               // 閲覧範囲制限
    this.chronologicalDisplayPhase = 'off';  // 築造順表示処理の段階
    this.highlightInterval = 1750;
    const over200 = this.locale === 'zh-TW' ? '200m以上' : this.translationsExtend.facet.moundLength.value.over200;
    this.specialFacetValues = [       // 築造順表示対象の古墳データを取得する専用のファセット値
      '4世紀後半',
      '5世紀前半',
      '5世紀後半',
      over200
    ];
    
    // 古代地形図の表示座標
    this.terrainMapBounds = {
      north: 34.8962,
      south: 34.4518,
      east: 135.7214,
      west: 135.3416
    };
    // 地図ビュー切替え時の地図中心位置
    this.defaultMapCenter = {
      lat: 34.581911,
      lng: 135.549748
    }
    // 展示モード用の初期位置（「グランフロント大阪・ナレッジキャピタル」）
    this.initLocationOnBigpad = {
      lat: 34.705913,
      lng: 135.494468
    };
    this.geolocationBounds = {
      minLat: 34.274057,
      maxLat: 35.051187,
      minLng: 135.091399,
      maxLng: 135.746522
    };
    this.showDetailFromTooltipMode = false;
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    let urlParams = that.getQueryString();
    let moundShape = that.translationsExtend.facet.moundShape.name;
    let moundLengthName = that.translationsExtend.facet.moundLength.name;
    let moundLengthDetail = that.translationsExtend.attributes.moundLength;
    let moundEra = that.translationsExtend.facet.era.name;
    
    // 展示モード(URLパラメータ: "bigpad=true")の場合、
    // 　・初期位置を「グランフロント大阪・ナレッジキャピタル」に変更する
    // 　・管理画面で設定された初期位置は initLocationOrigin に保存する
    // (※ Mapオブジェクト生成前の処理)
    if ('bigpad' in urlParams) {
      that.initLocationOrigin = that.init_location;
      that.init_location = that.initLocationOnBigpad;
      this.mapOptions.gmap_options_default.zoom = 12;
    }
    
    $(that).on('ready', function(){
      that.show_direction_on_marker_click = false;
      
      // ビューポートに地図を表示する操作の設定
      that.controlFeatureAndViewPort();
      
      // 非表示ファセット値による検索範囲の限定
      that.searchBySecretFacetValue([that.repositoryOptions.firstSelection]);
      
      // GoogleAnalyticsで取得するイベントの設定
      that.setGoogleAnalytics();
  
      // 地形図表示
      that.controlTerrainMapLayers();
  
      // 年代区分順表示
      that.controlChronologicalDisplay();

      // fitBoundsと古墳マーカの設定
      that.setFitBoundsAndMarkerImage();
      //
      // // 築造順表示
      // that.controlConstructionOrderSearch();
      //
      // // ズームレベルによる古墳マーカのラベルの表示・非表示の切替え
      that.showMarkerLabelByZoomLevel();
  
      // ツールチップから詳細パネル表示
      that.showDetailFromTooltip();
      
      // 検索結果タイル表示時は特集メニューを無効化
      $('.ih-expand-result-button').on('click', () => {
        $('.mf-footer-menu-feature').addClass('ui-disabled');
      });
      $('.ih-collapse-result-button').on('click', () => {
        $('.mf-footer-menu-feature').removeClass('ui-disabled');
      });
  
      // GPS現在地連動モードに移行
      $('.js-user-location').on('click', function(){
        let elm = $(this);
        that.shiftToLocationMode().then(function(){
          elm.closest('.ui-popup').popup('close');
        });
        return false;
      });
      
      // 展示モードの場合、
      //　・<body> に bigpadクラスを付与する
      //　・閲覧範囲を制限する
      // (※ Mapオブジェクト生成後の処理)
      if (urlParams.bigpad) {
        $('body').addClass('bigpad');
        that.extent = new google.maps.LatLngBounds(
          new google.maps.LatLng(that.terrainMapBounds.south, that.terrainMapBounds.west),
          new google.maps.LatLng(that.terrainMapBounds.north, that.terrainMapBounds.east)
        );
        that.map.getMap().addListener('center_changed', evt => that.restrictBounds(evt));
      }
    });
    
    $(that).on('ihFillSearchResult', (event, place, item) => {
      // 検索結果一覧に墳丘長を表示する
      let text = moundLengthName + ' ' + place.attributes[moundLengthDetail];
      item.find('.sr-info').text(text);
      // 画像一覧に資産番号を表示する
      let no = place.attributes[ that.translationsExtend.attributes.no ].toString();
      let $no = $('<span class="mf-tile-kofun-no">[' + no + '] </span>');
      $no.prependTo(item.find('.sr-name'));
    });
    $(that).on('ihFillMarkerPopup', function (event, place, popup) {
      // 詳細パネル: アプリ固有の項目を作成する
      that.createDetailMenus(place, popup);
      // 詳細パネル: 画像ポップアップを作成する
      that.createImagePopup(place, popup);
      // マーカポップアップに墳丘長を表示する
      let markerInfo = moundLengthName + ' ' + place.attributes[moundLengthDetail];
      popup.find('.iw-desc').text(markerInfo);
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes() {
    let types = [];
    for (let i in this.searchTargetTypes) {
      if (this.searchTargetTypes[i]) {
        types.push(i);
      }
    }
    return types;
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      let index = i + 1;
      
      // 施設オブジェクトに項目名と同じプロパティあれば、プロパティ値を項目の内容として表示
      if (attr in place.attributes) {
        text = place.attributes[attr];
        
        if ( i === this.indexOfCandidate && text !== '' ) {
          text = '[' + text.toString() + '] ';
          popup.find('.mf-kofun-number').text(text);
        }
        if ( i === this.indexOfMoundLength ) {
          attr = this.translationsExtend.facet.moundLength.name;
        }
        if ( this.locale !== 'ja' &&  i === this.indexOfKana ) {
          text = '';
        }
        
        if ( i === this.indexOfCandidate || text !== '' ) {
          popup.find('.iw-facet-' + index).closest('.iw-item').find('.iw-label').text(attr);
          popup.find('.iw-facet-' + index).html(text);
          popup.find('.iw-facet-' + index).closest('.iw-item').show();
        } else {
          popup.find('.iw-facet-' + index).closest('.iw-item').hide();
        }
        
        
      } else {
        popup.find('.iw-facet-' + index).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    let credit = [];
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePaths = place.image.split('|');
      let imageTitles = place.attributes['キャプション'].split('|');
      let numOfImages = imagePaths.length;
      credit = place.image_label.split('|');
  
      // 画像パス・写真提供元を整形
      for(let i = 0; i < numOfImages; i++) {
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
    
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      }
  
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      if(numOfImages > 1){
        if (this.locale === 'en') {
          $('.iw-image-count').text(`${numOfImages} ${this.translationsCommon.imageSlider.number}`);
        } else {
          $('.iw-image-count').text(`${numOfImages}${this.translationsCommon.imageSlider.number}`);
        }
      } else {
        $('.iw-image-count').text('');
      }
  
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        imagePopup.popup();
        
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">' + this.translationsExtend.ui.close + '</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
  
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + imageTitles[i] + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        } else {
          $('<div class="sliding-images"><img title="' + imageTitles[i] + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
      }
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: function($slideElement, oldIndex, newIndex){
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
            $('.mf-carousel-credit').remove();
            if (credit[newIndex].indexOf('none') === -1) {
              const _credit = credit[newIndex].replace('<br>', ' ');
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + _credit + '</span>');
            }
          },
          onSliderLoad: function (currentIndex) {
            $('.mf-carousel-credit').remove();
            if (credit[0].indexOf('none') === -1) {
              const _credit = credit[0].replace('<br>', ' ');
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + _credit + '</span>');
            }
          }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').html(credit[0]);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * 閲覧範囲を制限する
   *
   */
  restrictBounds() {
    if (this.extent.contains(this.map.getCenter())) {
      return;
    }
    
    let maxLat = this.extent.getNorthEast().lat(),
        maxLng = this.extent.getNorthEast().lng(),
        minLat = this.extent.getSouthWest().lat(),
        minLng = this.extent.getSouthWest().lng(),
        lat = this.map.getCenter().lat(),
        lng = this.map.getCenter().lng();
  
    if (maxLat < lat) {
      lat = maxLat;
    }
    if (maxLng < lng) {
      lng = maxLng;
    }
    if (minLat > lat) {
      lat = minLat;
    }
    if (minLng > lng) {
      lng = minLng;
    }
    
    // setCenter()による即時中心位置変更ができなくなった
    this.map.getMap().panTo(this.map.createLatLng(lat, lng));
  }
  
  /**
   * 未表示の施設オブジェクトを取得する
   */
  getNotDisplayedPlaces(){
    // 表示中のマーカを取得
    let markers = this.map.getDisplayMarkers();
    // 表示予定の施設オブジェクトを取得
    let places = this.map.getDisplayingPlaces();
    
    // 未表示の施設オブジェクトを返す
    _.remove(places, function(place){
      let flag = false;
      for (let key in markers) {
        if (place.id == key) {
          flag = true;
          break;
        }
      }
      return flag;
    });
    return places;
  }
  
  /**
   * 検索パネル、結果パネルの並替えボタンの有効・無効を切替る
   *
   * @param {boolean} disabled
   */
  disableNormalSearchMenu(disabled){
    if (disabled) {
      $('.js-search-type').addClass('ui-disabled');
      $('.ih-list-controller').addClass('ui-disabled');
    } else {
      $('.js-search-type').removeClass('ui-disabled');
      $('.ih-list-controller').removeClass('ui-disabled');
    }
  }
  
  /**
   * ツールチップから特定の古墳のみ表示する（検索メニューとは独立）
   */
  showDetailFromTooltip(){
    const that = this;
    $('.mf-tooltip-to-detail').on('click', function () {
      let placeType = $(this).data('kofun');
      
      // 年代区分順表示中かつ検索メニューが有効な場合は年代区分順表示を中断し、並び替えキーを資産番号順にする
      if (that.chronologicalDisplayPhase !== 'off') {
        that.chronologicalDisplayPhase = 'off';
        that.repository.sortOrder = -1;
        that.repository.sortKey = 'era';
        $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
      }
      
      $('.js-tooltip-display').popup('close');
      
      // ID検索を応用
      that.searchById(placeType);
    });
  }
  
  controlFeatureAndViewPort () {
    $('.mf-footer-menu-view').on('click', () => {
      if (!this.isMapViewDisplayed()) {
        this.showMapView();
      } else {
        this.showTileView();
      }
    });
    $('.mf-footer-menu-feature').on('click', () => {
      if (!this.isMapViewDisplayed()) {
        this.showMapView();
      }
    });
    $('.mf-motion-selector').on('click', () => {
      if (!this.isMapViewDisplayed()) {
        this.showMapView();
      }
    });
    $('.ih-footer-menu-search').on('click', () => {
      if (this.isMapViewDisplayed()) {
        this.showTileView();
      }
    });
  }
  /**
   * ビューポートの表示が地図かどうか
   *
   * @returns {Boolean}
   */
  isMapViewDisplayed () {
    return $('#gmap').is(':visible');
  }
  
  /**
   * 非表示ファセット値で検索範囲を限定する
   * @param facetValues
   */
  searchBySecretFacetValue (facetValues) {
    const facetValueIds = this.repository.getFacetValueIdsByName(facetValues);
    const len = facetValueIds.length;
    for (let i = 0; i < len; i++) {
      if (facetValueIds[i]) {
        this.searchTargetTypes[facetValueIds[i]] = true;
      }
    }
  }
  
  /**
   * 地形図レイヤー作成・表示変更
   * 特集 地形図表示機能専用
   *
   * @private
   */
  controlTerrainMapLayers () {
    // 地形図切替時にヘッダーにセットするアプリ名の設定
    const $header = $('#header h1.ui-title');
    const defaultTitle = this.options.title;
    const terrainMapTitle = this.options.title + this.translationsExtend.ancientMap.kofun;
  
    // 古墳時代地形図レイヤー作成
    const mapLayer = this.map.createStaticImageLayer(
      this.place_image_path + 'img/maps/3.jpg',
      this.terrainMapBounds,
      0.65
    );
    
    $('.mf-map-selector').on('change', () => {
      const checked = $('.mf-kofun-era-terrain-map').prop('checked');
      if (checked) {
        $header.text(terrainMapTitle);
        // 地形図表示
        this.map.addLayer(mapLayer);
        // 地形図の中心位置を調整
        const center = this.map.createLatLng(this.defaultMapCenter.lat, this.defaultMapCenter.lng);
        this.map.setCenter(center);
        // ビューポートが写真一覧の場合は地図に切り替え
        // ビューポートが地図の場合はズームを調整
        if (!this.isMapViewDisplayed()){
          this.forceChangeViewport('map');
        } else {
          this.map.setZoom(this.defaultZoom)
        }
      } else {
        $header.text(defaultTitle);
        this.map.removeLayer(mapLayer);
      }
    });
  }
  
  /**
   * 時代区分順表示 再生処理制御
   */
  controlChronologicalDisplay () {
    const that = this;
  
    this.disableChronologicalMenu({step: false, play: false, pause: true, clear: true});
    
    $('.mf-ctrl-btn').on('click', function () {
      const mode = $(this).val();
      // 通常再生
      if (mode === 'play') {
        that.map.interval = 1750;
        that.playChronologically();
      }
      // 一時停止
      if (mode === 'pause') {
        that.pauseChronologically();
      }
      // ステップ再生
      if (mode === 'step') {
        that.map.interval = 0;
        that.stepPlayChronologically();
      }
      // 表示消去
      if (mode === 'clear') {
        // 築造順テーブルのハイライトする行を元に戻す
        that.clearChronologically();
      }
    });
  
    // 年代区分順表示開始後、検索メニューの各データ数を初期化する
    // (通常検索とは独立させるため)
    $(this.controller).on('ihAfterUpdateFacetValue', () => {
      if (this.chronologicalDisplayPhase !== 'off') {
        this.initSearchMenu();
      }
    });
    // 年代区分順表示開始・検索メニューデータ件数初期化後、検索メニューを再無効化する
    // (データ件数初期化によって検索メニューが有効化されるため)
    $(this).on('ihAfterRequestPlaces', (event, request, places) => {
      if (this.chronologicalDisplayPhase === 'playing') {
        $('.js-search-type').addClass('ui-disabled');
      }
    });
    $(this.map).on('ihDisplayedOneGroupMarker', (event, places, place, marker, popup) => {
      if (this.chronologicalDisplayPhase === 'playing' || this.chronologicalDisplayPhase === 'stepping') {
        this.disableChronologicalMenu({step: true, play: true, pause: false, clear: true});
        $('.highlighting').removeClass('highlighting');
        if (place.attributes['年代区分'] === '4世紀後半') {
          const $early = $('.mf-const-early');
          $early.addClass('highlighting');
          $early.removeClass('before-highlighting');
        }
        if (place.attributes['年代区分'] === '5世紀前半') {
          const $mid = $('.mf-const-mid');
          $mid.addClass('highlighting');
          $mid.removeClass('before-highlighting');
        }
        if (place.attributes['年代区分'] === '5世紀後半') {
          const $late = $('.mf-const-late');
          $late.addClass('highlighting');
          $late.removeClass('before-highlighting');
        }
      }
    });
    // 全古墳マーカー表示後
    $(this.map).on('ihDisplayedAllMarkers', (event, places, marker, popup) => {
      if (this.chronologicalDisplayPhase !== 'off' && this.chronologicalDisplayPhase !== 'displayed') {
        this.chronologicalDisplayPhase = 'displayed';
  
        this.disableChronologicalMenu({step: true, play: true, pause: true, clear: true});
        setTimeout(() => {
          $('.highlighting').removeClass('highlighting');
          this.disableChronologicalMenu({step: false, play: false, pause: true, clear: false});
        }, 1750)
        
        // 通常検索の実行(通常検索への移行)も可能にする
        this.clearChronologicalSettings();
        this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
      }
    });
    // 検索メニューが有効な状態で検索メニューを選んだ場合は通常検索を行う (年代区分表示から通常検索へ移行)
    $('.js-facet-selector').on('change', () => {
      if (this.chronologicalDisplayPhase !== 'off') {
        this.chronologicalDisplayPhase = 'off';
        this.disableChronologicalMenu({step: false, play: false, pause: true, clear: true});
      }
    });
  }
  /**
   * 時代区分順表示 通常再生
   */
  playChronologically () {
    this.disableChronologicalMenu({step: true, play: true, pause: true, clear: true});
    // 「一時停止中」の場合、未表示の古墳を取得して表示を再開する
    if (this.chronologicalDisplayPhase === 'pausing') {
      let places = this.getNotDisplayedPlaces();
      this.map.displayMarkers(null, places);
      this.chronologicalDisplayPhase = 'playing';
    } else {
      if (this.chronologicalDisplayPhase !== 'stepping') {
        this.chronologicalDisplayPhase = 'playing';
      }
      // 検索メニュー・並替えボタンを無効化する
      this.disableNormalSearchMenu(true);
      // 年代区分順表の古墳名を灰色にする
      // 表示状態に合わせて年代区分順表を以下のように変更する
      // 　・未表示: 文字（灰色）
      // 　・表示中: 文字（黒色）＋ 背景（緑色）
      // 　・表示済: 文字（黒色）
      $('.mf-const-table td').addClass('before-highlighting');
      // 専用のリクエストを生成して表示開始
      this.initChronologicalDisplay();
      this.searchFromBaseMarker();
    }
  }
  /** 時代区分順表示 一時停止
   *
   */
  pauseChronologically () {
    this.disableChronologicalMenu({step: false, play: false, pause: true, clear: false});
    // 年代区分順表示の段階を「一時停止中」にする
    if (this.chronologicalDisplayPhase !== 'displayed') {
      this.chronologicalDisplayPhase = 'pausing';
    }
    // 古墳マーカーの表示を一時停止する
    const timerIds = this.map.getTimerID();
    if (timerIds.length !== 0) {
      for (let i = 0; i < timerIds.length; i++) {
        clearTimeout(timerIds[i]);
      }
    }
  }
  /**
   * 時代区分順表示 ステップ再生
   */
  stepPlayChronologically () {
    // 通常再生を行い、1つのグループが表示されると一時停止する（この繰り返しによってステップ再生を行う）
    this.playChronologically();
    this.chronologicalDisplayPhase = 'stepping';
    $(this.map).on('ihDisplayedOneGroupMarker', (event, places, place, marker, popup) => {
      if (this.chronologicalDisplayPhase === 'stepping') {
        this.pauseChronologically();
      }
    });
  }
  /**
   * 時代区分順表示 表示消去
   */
  clearChronologically () {
    $('.highlighting').removeClass('highlighting');
    $('.mf-const-table td').removeClass('before-highlighting');
    this.chronologicalDisplayPhase = 'clear';
    this.clearChronologicalSettings();
    this.disableChronologicalMenu({step: false, play: false, pause: true, clear: true});
    this.searchFromBaseMarker();
    $(this.controller).on('ihAfterUpdateFacetValue', () => {
      if (this.chronologicalDisplayPhase === 'clear') {
        this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
        this.initSearchMenu();
        this.chronologicalDisplayPhase = 'off';
      }
    });
  }
  /**
   * 時代区分順表示 UIの有効・無効制御
   * 
   * @param disables
   */
  disableChronologicalMenu(disables){
    $('.mf-ctrl-btn').each(function () {
      const type = $(this).val();
      const elem = $(this).parent().parent();
      if (disables[type]) {
        elem.addClass('ui-disabled');
      } else {
        elem.removeClass('ui-disabled');
      }
    });
  }
  /**
   * 時代区分順表示 専用リクエスト生成
   */
  initChronologicalDisplay () {
    this.map.isChronological = true;
    this.repository.sortKey = 'era';
    this.repository.sortOrder = 1;
    this.controller.clearAllSelector();
    this.searchTargetTypes = [];
    this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
    const facetValueIds = this.repository.getFacetValueIdsByName(this.specialFacetValues);
    facetValueIds.forEach(id => {
      this.searchTargetTypes[id] = true;
    })
  }
  /**
   * 年代区分順表示 専用設定をクリア（通常設定に戻す）
   */
  clearChronologicalSettings () {
    this.map.interval = 0;
    this.map.isChronological = false;
    this.repository.sortOrder = 1;
    this.repository.sortKey = 'era';
    this.searchTargetTypes = [];
    this.disableNormalSearchMenu(false);
    $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
    $('#all-clear-button').prop('disabled', false);
    $('#all-clear').find('.ui-btn-inner').css('color', 'black');
  }
  
  showMarkerLabelByZoomLevel () {
    let labelStyle = {
      color: "#493E26",
      fontSize: "14px",
      fontWeight: '400',
      fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
        'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
      text: ''
    };
    $(this).on('ihChangeZoom', (event, zoom) => {
      const markers = this.map.getDisplayMarkers();
      if (Object.keys(markers).length !== 0) {
        $.each(markers, (index, marker) => {
          if (zoom < this.labelingZoomLevel) {
            labelStyle.text = '';
            this.map.setMarkerLabel(marker, labelStyle);
          } else if (zoom >= this.labelingZoomLevel && this.chronologicalDisplayPhase === 'off') {
            if (this.mapOptions.type === 'googlemap') {
              labelStyle.text = marker.name;
            } else if (this.mapOptions.type === 'openlayer') {
              labelStyle.text = marker.get('name');
            }
            this.map.setMarkerLabel(marker, labelStyle);
          }
        });
      }
    });
  }
  
  setGoogleAnalytics () {
    if (ga) {
      // メニューボタンを押した時
      $("#footer").on("click", function (event) {
        let label = $(event.target).text().trim();
        if (label.length > 4) {
          label = label[0] + label[1];
        }
        if (label !== '') {
          ga('send', 'event', 'メニュー', 'メニューボタンを押す', label);
        }
      });
    
      // 詳細パネルを開いた時
      $("#page-place").on("panelopen", function () {
        let label = $(this).find('.iw-name').text() + '（' + $(this).find('.iw-type').text() + '）';
        ga('send', 'event', '詳細パネル', '詳細パネルを開く', label);
      
      });
    
      // 特集パネルの地形図選択ボタンを押した時
      $(".mf-map-selector").on("click", function (event) {
        let label = $(event.target).text().trim();
        if (label !== '') {
          ga('send', 'event', '古代地形図', '地形図選択ボタンを押す', label);
        }
      });
    
      // 特集パネルの築造順表示操作ボタンを押した時
      $(".mf-ctrl-btn").on("click", function (event) {
        let elem = $(event.target);
        let label = elem.text().trim();
        if (label === '') {
          label = elem.find('img').attr('alt');
        }
        if (label !== '') {
          ga('send', 'event', '築造順表示', '表示操作ボタンを押す', label);
        }
      });
    
      // 特集パネルの築造順表示操作ボタンを押した時
      $(".mf-cluster-selector").on("click", function (event) {
        let elem = $(event.target);
        let label = '';
        if (!elem.is('p')) {
          label = elem.text().trim();
        }
        if (label !== '') {
          ga('send', 'event', '築造順表示', '古墳群選択ボタンを押す', label);
        }
      });
    }
  }
  
  setFitBoundsAndMarkerImage () {
    const moundShapes = this.translationsExtend.facet.moundShape.value;
    const moundShape = this.translationsExtend.facet.moundShape.name;
    const moundLengthName = this.translationsExtend.facet.moundLength.name;
    $(this).on('ihAfterTransformPlacesResponse', (event, request, places) => {
      this.controller.options.fit_bounds = false;
    
      _.forEach( places, (value, key) => {
        // ビューポートに対象の古墳が全て収まる場合は、fitBoundsを行わない
        if (this.isMapViewDisplayed() && 
          (this.map.getNorthEnd() < value.lat ||
          this.map.getEastEnd() < value.lng    ||
          this.map.getSouthEnd() > value.lat   ||
          this.map.getWestEnd() > value.lng )
        ) {
          this.controller.options.fit_bounds = true;
        }
      
        // 古墳オブジェクトごとにマーカのアイコン画像を設定する
        if ( value.attributes[moundShape] === moundShapes.keyholeShaped )
        {
          places[key].icon_pin = this.icon_file_path + 'keyhole_pin.png';
          places[key].icon_min = this.icon_file_path + 'keyhole_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.scallopShaped )
        {
          places[key].icon_pin = this.icon_file_path + 'scallop_pin.png';
          places[key].icon_min = this.icon_file_path + 'scallop_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.round ) {
          places[key].icon_pin = this.icon_file_path + 'round_pin.png';
          places[key].icon_min = this.icon_file_path + 'round_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.square ) {
          places[key].icon_pin = this.icon_file_path + 'square_pin.png';
          places[key].icon_min = this.icon_file_path + 'square_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.unknown ) {
          places[key].icon_pin = this.icon_file_path + 'unknown_pin.png';
          places[key].icon_min = this.icon_file_path + 'unknown_min.png';
        }
      });
    });
  }
  
  /**
   * @override
   */
  createMap(options) {
    return new GoogleMap(this.mapEvents, this.popupFactory, this.placeType, options);
  }
  searchById (id) {
    super.searchById(id);
    if (!this.isMapViewDisplayed()) {
      this.showMapView();
    }
  }
  initSearchTargetTypes () {
    this.searchTargetTypes = [];
    this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
  }
  initSearchMenu () {
    const ids = this.repository.getFacetValueIdsByName([this.repositoryOptions.firstSelection]);
    const request = new Request({types: ids});
    this.controller.displayNumberOfFacetValue(request, false);
  }
  // 時代順並び替えを資産番号順並び替えに置き換え
  transformPlacesResponse (request, response) {
    if (this.repository.sortKey === 'era'){
      response.places = _.sortBy(response.places, (kofun) => {
        const no = this.translationsExtend.attributes.no;
        let value = kofun.attributes[no].replace(/([|])/, '');
        value = value.replace('-', '.');
        if (!value){
          return 1000;
        }
        return parseFloat(value) * this.repository.sortOrder;
      });
    }
    return super.transformPlacesResponse(request, response);
  }
  showMapView () {
    super.showMapView();
    const $map = $('.mf-view-switcher-off-right');
    const $photo = $('.mf-view-switcher-on-left');
    $map.addClass('mf-view-switcher-on-right');
    $map.removeClass('mf-view-switcher-off-right');
    $photo.addClass('mf-view-switcher-off-left');
    $photo.removeClass('mf-view-switcher-on-left');
  }
  showTileView () {
    super.showTileView();
    const $map = $('.mf-view-switcher-on-right');
    const $photo = $('.mf-view-switcher-off-left');
    $map.addClass('mf-view-switcher-off-right');
    $map.removeClass('mf-view-switcher-on-right');
    $photo.addClass('mf-view-switcher-on-left');
    $photo.removeClass('mf-view-switcher-off-left');
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozuFuru.js